<template>
  <div class="vs__wrapper">
    <v-select v-model="selectedOptions"
              :options="options"
              :placeholder="label"
              :disabled="disabled"
              :multiple="selectMultiple"
              :close-on-select="closeOnSelect"
              deselect-from-dropdown
              :filterable="false"
              :searchable="false"
              :reduce="(option) => option.value"
              @input="$emit( 'update', selectedOptions )">
      <template #header>
        <slot name="header">
        </slot>
      </template>
      <template #no-options>
        <slot name="no-options"></slot>
      </template>
      <template #selected-option-container="{ option }">
        <div class="selected-option">
          {{ option.value }}
        </div>
      </template>
      <template #option="option">
        <font-awesome-icon :icon="['fas', 'chevron-right']"
                           class="option-chevron"
                           size="xs"></font-awesome-icon>
        {{ option.label }}
        <font-awesome-icon
          class="selected-check"
          aria-hidden="true"
          icon="check"></font-awesome-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
import VSelect from "vue-select";

export default {
  name: "AnimatedDropdown",
  components: {
    VSelect
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    selectMultiple: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedOptions: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler ( val ) {
        if ( Array.isArray( val ) && val.every( option => !!option ) ) {
          this.selectedOptions = val;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

/deep/ .vs--open {
  .vs__dropdown-toggle {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  }
}

.vs__wrapper {
  width: 100%;
}

.v-select .vs {

  /deep/ &__dropdown-toggle {
    padding: 0;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid @color-accent-1 !important;
  }

  /deep/ &__search {
    margin: 0;
    padding: 10px 0;
    border: none;

    &:focus {
      border: none;
      box-shadow: none !important;
    }

    &::placeholder {
      font-size: 1rem;
      font-weight: 500;
      color: #3c3c3b !important;
      opacity: 1;
    }
  }

  /deep/ &__dropdown-menu {
    border-radius: 0;
    border: none;
    top: calc(100%);
  }

  /deep/ &__selected-options {
    display: flex;
    align-items: center;
    margin-left: 20px;
    padding: 0;

    & > .selected-option {
      margin-right: .3rem;
      display: flex;

      &:not(:last-of-type)::after {
        content: ",";
        display: block;
      }
    }

    .selected-option {
      font-size: .88rem;
    }
  }

  /deep/ &__dropdown-option {
    border: none;
    display: flex;
    align-items: center;
    margin: 0 20px;
    padding: 10px 0;

    &:not(:last-child) {
      border-bottom: 1px solid #aaa;
    }

    .option-chevron {
      margin-right: 0.5rem;
    }

    .selected-check {
      display: none;
    }

    &--highlight {
      background-color: #fff;
      color: inherit;
    }

    &--selected {
      background-color: #fff;

      .selected-check {
        display: inline-block;
        margin-left: auto;
        color: @color-accent-1;
      }
    }
  }

  /deep/ &__open-indicator {
    fill: #3c3c3b;
    transform: scale(0.7);
  }
}
</style>
